import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3;
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Store } from 'libx';
import { action, observable, computed } from 'mobx';
import { task } from 'mobx-task';
import NewTeamViewState from './NewTeamViewState';
import { sortArray } from 'utils/sortUtil';

/**
 * Team management store.
 */
var TeamManagementStore = (_dec = action.bound, _dec2 = action.bound, _class = /*#__PURE__*/function (_Store) {
  function TeamManagementStore() {
    var _this;
    _classCallCheck(this, TeamManagementStore);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TeamManagementStore, [].concat(args));
    _initializerDefineProperty(_this, "searchText", _descriptor, _this);
    // true means desc, false means asc
    _initializerDefineProperty(_this, "sortOrder", _descriptor2, _this);
    _initializerDefineProperty(_this, "sortField", _descriptor3, _this);
    _this.newTeamState = new NewTeamViewState({}, {
      rootStore: _this.rootStore
    });
    return _this;
  }
  _inherits(TeamManagementStore, _Store);
  return _createClass(TeamManagementStore, [{
    key: "teams",
    get:
    /**
     * Teams where the current user is a member.
     */
    function get() {
      return this.rootStore.teamMemberStore.teamMembersForWorkspaceMemberByPublicId().map(function (m) {
        return m.team;
      });
    }

    /**
     * Fetches the teams.
     */
  }, {
    key: "activate",
    value: (function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.rootStore.teamMemberStore.fetchUserTeamMembersByPublicId();
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }())
  }, {
    key: "filtered",
    get: function get() {
      var _this2 = this;
      if (this.searchText === '') {
        return sortArray(this.teams, this.sortField, this.sortOrder);
      }
      return sortArray(this.teams.filter(function (s) {
        return s.name.toLowerCase().includes(_this2.searchText.toLowerCase()) || s.owner.member.displayName.toLowerCase().includes(_this2.searchText.toLowerCase());
      }), this.sortField, this.sortOrder);
    }
  }, {
    key: "sort",
    value: function sort(field) {
      if (this.sortField === field) {
        this.sortOrder = !this.sortOrder;
      } else {
        this.sortField = field;
        this.sortOrder = true;
      }
    }
  }, {
    key: "setSearchText",
    value: function setSearchText(val) {
      this.searchText = val;
    }
  }]);
}(Store), _descriptor = _applyDecoratedDescriptor(_class.prototype, "searchText", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sortOrder", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sortField", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'name';
  }
}), _applyDecoratedDescriptor(_class.prototype, "teams", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "teams"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "activate", [task], Object.getOwnPropertyDescriptor(_class.prototype, "activate"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "filtered", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "filtered"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "sort", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "sort"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSearchText", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "setSearchText"), _class.prototype), _class);
export { TeamManagementStore as default };
//# sourceMappingURL=TeamManagementStore.js.map
